var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowRightLong = function SvgIconArrowRightLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.096.976 2.812 2.812c.06.06.092.14.092.203s-.03.16-.092.221L8.096 7.025a.312.312 0 1 1-.442-.442l2.28-2.28H1.312C1.14 4.304 1 4.164 1 4.01c0-.173.14-.313.313-.313h8.62l-2.279-2.28a.312.312 0 1 1 .442-.44Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeLinejoin: "round"
  })));
};
export default SvgIconArrowRightLong;